export var InventoryDetail;
(function (InventoryDetail) {
    InventoryDetail["INVENTORY_DETAIL_DYNAMODB_INDEXES"] = "DYNAMODB_INDEXES";
})(InventoryDetail || (InventoryDetail = {}));
